/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const boxCommonStyle = {
  content: {
    padding: "1.5rem",
    height: "100%",
    width: "100%",
  },
  boxGrid: {
    height: "100%",
  },
  boxMain: {
    flex: "1 0 auto",
    paddingTop: "1.5rem",
  },
  boxFooter: {
    flexShrink: 0,
  },
  buttonContainer: {
    textAlign: "center",
  },
  button: {
    color: "primary.main",
  },
};

export default boxCommonStyle;
